import LazyLoad from "vanilla-lazyload";

const lazyLoad = {};

lazyLoad.init = () => {
    const globalLazyLoad = new LazyLoad({
        elements_selector: ".lazy",
        class_loading: "lazy-loading" // avoid conflict with .loading class
    });

    // var inputLazy = document.querySelectorAll('input'),
    //     resultInput;
    //
    // for (var i = 0; i < inputLazy.length; i++) {
    //     resultInput = inputLazy[i];
    //     resultInput.addEventListener('click', function() {
    //         globalLazyLoad.update();
    //     });
    // }
};

export default lazyLoad;
